import React from 'react';

const VulnerabilityIcon: React.FC<{ height?: string; width?: string }> = ({
  height = 32,
  width = 32,
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M29.1411 3.2286C20.6901 11.6786 12.2401 -5.2224 3.78909 3.2286V20.1286C12.2401 11.6786 20.6901 28.5806 29.1411 20.1286V3.2286Z"
        fill="#6000FE"
      />
      <path
        d="M28.352 19.795C26.934 21.13 25.437 21.779 23.785 21.779H23.784C21.531 21.779 19.242 20.635 16.818 19.424C14.337 18.184 11.772 16.9 9.146 16.9C7.498 16.9 5.991 17.399 4.578 18.416V3.562C5.996 2.227 7.493 1.578 9.146 1.578C11.399 1.578 13.688 2.723 16.112 3.934C18.593 5.174 21.158 6.457 23.784 6.457C25.432 6.456 26.939 5.959 28.352 4.941V19.795ZM29.443 2.499C29.148 2.377 28.809 2.444 28.583 2.67C27.097 4.156 25.527 4.879 23.783 4.879C21.53 4.879 19.241 3.734 16.817 2.523C14.337 1.282 11.772 0 9.146 0C7.498 0 5.991 0.498001 4.578 1.516V0.789C4.578 0.354 4.225 0 3.789 0C3.353 0 3 0.354 3 0.789V3.227C3 3.227 3 3.228 3 3.229V20.129C3 20.13 3 20.131 3 20.131V31.211C3 31.647 3.353 32 3.789 32C4.225 32 4.578 31.647 4.578 31.211V20.463C5.996 19.129 7.493 18.479 9.146 18.479C11.4 18.479 13.689 19.623 16.113 20.835C18.593 22.074 21.158 23.358 23.783 23.358H23.785C25.967 23.358 27.902 22.484 29.699 20.688C29.847 20.539 29.93 20.338 29.93 20.129V3.229C29.93 2.908 29.738 2.621 29.443 2.499Z"
        fill="black"
      />
    </svg>
  );
};

export default VulnerabilityIcon;
